export default "__VITE_ASSET__D$$pfYNF__"